// This file was automatically generated from appchart.visitNote.cdsDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.cdsDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.cdsDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><h2 class="sectionTopHeader el8AlignCenter cds-name"></h2><ol class="cds-actions-content quickSelectContainer"></ol></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.cdsDialog.options = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var optionList6007 = opt_data.options;
  var optionListLen6007 = optionList6007.length;
  for (var optionIndex6007 = 0; optionIndex6007 < optionListLen6007; optionIndex6007++) {
    var optionData6007 = optionList6007[optionIndex6007];
    el8.template.appchart.visitNote.cdsDialog._option(soy.$$augmentData(optionData6007, {idx: optionIndex6007}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.cdsDialog._option = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li><button class="el8button cds-option quickSelectButton" data-index="', soy.$$escapeHtml(opt_data.idx), '">', soy.$$escapeHtml(opt_data.responseLabel), '</button></li>');
  if (!opt_sb) return output.toString();
};
